// import React from "react";
import { useLayoutEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigationType } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import HowMuchHotter from "./components/HowMuchHotter";
import ResultsPage from "./components/ResultsPage";
import CitiesPage from "./components/CitiesPage";
import "./components/styles.css";

// Open each newly visited page at the top (React Router keeps the previous
// page's scroll position otherwise, e.g. a city card tapped far down the
// landing page). Back/forward (POP) are left alone so the browser can restore
// where the visitor was.
function ScrollToTop() {
  const { key } = useLocation();
  const navigationType = useNavigationType();
  useLayoutEffect(() => {
    if (navigationType !== "POP") window.scrollTo(0, 0);
  }, [key, navigationType]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HowMuchHotter />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/cities" element={<CitiesPage />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
